module.exports = __webpack_public_path__ + "img/Image wrap.902d8ff9.png";